export default __webpack_public_path__ + "static/media/icon-eye.43e7e1a9.svg";